import CloseIcon from '~/assets/icons/ontario-icon-close.svg';
import { styled } from 'styled-components';
import { color, media, spacing } from '~/theme';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${color.palette.systemInformationBlue};
    border-bottom: 1px solid ${color.palette.greyscale20};
    padding: ${spacing.spacing4};
`;

export const InnerContainer = styled.div`
    width: 100%;
    max-width: 22.625rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${spacing.spacing0} ${spacing.spacing4};

    @media (${media.small}) {
        max-width: 48rem;
    }

    @media (${media.medium}) {
        max-width: 72rem;
    }
`;

export const StyledCreateAccount = styled.div`
    display: flex;
    width: 100%;
    gap: ${spacing.spacing2};

    a {
        margin-right: ${spacing.spacing2};
    }
    svg {
        width: ${spacing.spacing5};
        height: ${spacing.spacing5};
        min-width: ${spacing.spacing5};
        min-height: ${spacing.spacing5};
        flex-shrink: 0;
        align-self: center;
    }
`;

export const StyledCloseIcon = styled(CloseIcon)`
    vertical-align: middle;
    &:focus,
    &:active {
        box-shadow: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing1}
            ${color.focusBlue};
        outline: ${spacing.spacing1} solid transparent;
    }
`;
